import type { RequisitionDto } from '@eombor/contracts';

/**
 * QABUL QILISHGA TAYYOR yagona holat — «Berildi» (`HANDED_OVER`).
 *
 * Mahsulot berilgan, qabul esa hali tasdiqlanmagan. Aynan shu holat
 * `requisition.confirm.receipt` egasining navbatida turadi va serverning
 * o'zi ham shunday hisoblaydi:
 *
 *     HANDED_OVER: { permission: 'requisition.confirm.receipt', … }
 *     — apps/api/.../requisition/domain/inbox.ts
 *
 * Ya'ni ro'yxat allaqachon TO'G'RI odamga keladi va bu yerda faqat
 * holat bo'yicha ajratib olinadi: «Mening navbatim» da boshqa holatlar
 * ham bo'ladi (tasdiqlash kutayotgani, qoralama va hokazo).
 */
export const ACCEPT_STATUS = 'HANDED_OVER';

/**
 * Qabul qilinishi mumkin bo'lgan talabnomalar — eng YANGISI tepada.
 *
 * Tartib kamayish bo'yicha: odam odatda hozirgina bo'lgan ish bilan
 * ishlaydi, uzoq turib qolgani esa pastda kutadi. Sana `createdAt` dan
 * olinadi — «berilgan payt» ro'yxat javobida yo'q, u hujjat tarixida
 * yashaydi va uni har satr uchun alohida so'rash kerak bo'lardi.
 *
 * Nusxa qaytariladi: chaqiruvchining massivi joyida saralanib ketmasin.
 */
export const acceptQueueOf = (rows: readonly RequisitionDto[]): RequisitionDto[] =>
  rows
    .filter((row) => row.status === ACCEPT_STATUS)
    .sort((a, b) => b.createdAt.localeCompare(a.createdAt));

/**
 * Tugma KO'RINADIMI.
 *
 * Ikkala shart ham majburiy va ular alohida sinaladi, chunki qaror
 * sahifadan ajratilgan: sahifaning o'zi so'rovlar, ruxsatlar va
 * ko'rinishni bir joyga yig'adi, bu shart esa xatoga moyil joy — «faqat
 * mobil» qismi unutilsa, tugma desktopda ham chiqib ketardi.
 *
 * Alohida bayroq YO'Q: ko'rinish faqat ro'yxatning o'z holatidan
 * hisoblanadi, shuning uchun oxirgi element qabul qilingan zahoti tugma
 * o'z-o'zidan yo'qoladi.
 */
export const showsAcceptBar = (input: { mobile: boolean; count: number }): boolean =>
  input.mobile && input.count > 0;
